<footer >
  <img src="assets/svg/footer-background.svg" alt="Logo da Broadfactor" class="w-100">
</footer>
